module.exports = __webpack_public_path__ + "img/collection-weddingRingsBlack.c29a478.webp";